import { vistaI18nRoutesBy99dLocale } from './vistaI18nRoutesBy99dLocale';

const vistaprintDesignBusinessCardsUrls: { [key: string]: string } = {
    'da-dk': '/eksperter/ydelser/detaljer/standardbusinesscards',
    'de-at': '/experten/services/details/standardbusinesscards',
    'de-ch': '/experten/services/details/standardbusinesscards',
    'de-de': '/experten/services/details/standardbusinesscards',
    'en-au': '/experts/services/details/standardbusinesscards',
    'en-ca': '/experts/services/details/standardbusinesscards',
    'en-gb': '/experts/services/details/standardbusinesscards',
    'en-ie': '/experts/services/details/standardbusinesscards',
    'en-in': '/experts/services/details/standardbusinesscards',
    'en-nz': '/experts/services/details/standardbusinesscards',
    'en-sg': '/experts/services/details/standardbusinesscards',
    'en-us': '/experts/services/details/standardbusinesscards',
    'es-es': '/expertos/servicios/detalles/standardbusinesscards',
    'es-us': '/expertos/servicios/detalles/standardbusinesscards',
    'fi-fi': '/ammattilaiset/palvelut/tiedot/standardbusinesscards',
    'fr-be': '/experts/services/details/standardbusinesscards',
    'fr-ca': '/experts/services/details/standardbusinesscards',
    'fr-ch': '/experts/services/details/standardbusinesscards',
    'fr-fr': '/experts/services/details/standardbusinesscards',
    'it-ch': '/esperti/servizi/dettagli/standardbusinesscards',
    'it-it': '/esperti/servizi/dettagli/standardbusinesscards',
    'nb-no': '/eksperter/tjenester/detaljer/standardbusinesscards',
    'no-no': '/eksperter/tjenester/detaljer/standardbusinesscards',
    'nl-be': '/experts/diensten/details/standardbusinesscards',
    'nl-nl': '/experts/diensten/details/standardbusinesscards',
    'pt-pt': '/especialistas/servicos/detalhes/standardbusinesscards',
    'sv-se': '/experter/tjänster/information/standardbusinesscards',
};

const vistaprintDesignTshirtsUrls: { [key: string]: string } = {
    'da-dk': '/eksperter/ydelser/detaljer/fruitoftheloombasictshirt',
    'de-at': '/experten/services/details/fruitoftheloombasictshirt',
    'de-ch': '/experten/services/details/fruitoftheloombasictshirt',
    'de-de': '/experten/services/details/fruitoftheloombasictshirt',
    'en-au': '/experts/services/details/gildanmenspoloshirt',
    'en-ca': '/experts/services/details/bellacanvasunisexshortsleevejerseytshirtdtg2go',
    'en-gb': '/experts/services/details/fruitoftheloombasictshirt',
    'en-ie': '/experts/services/details/fruitoftheloombasictshirt',
    'en-nz': '/experts/services/details/menstee',
    'en-sg': '/experts/services/details/gildanmenstshirt',
    'en-us': '/experts/services/details/bellacanvasunisexshortsleevejerseytshirtdtg2go',
    'es-es': '/expertos/servicios/detalles/fruitoftheloombasictshirt',
    'es-us': '/expertos/servicios/detalles/bellacanvasunisexshortsleevejerseytshirtdtg2go',
    'fi-fi': '/ammattilaiset/palvelut/tiedot/fruitoftheloombasictshirt',
    'fr-be': '/experts/services/details/fruitoftheloombasictshirt',
    'fr-ca': '/experts/services/details/bellacanvasunisexshortsleevejerseytshirtdtg2go',
    'fr-ch': '/experts/services/details/fruitoftheloombasictshirt',
    'fr-fr': '/experts/services/details/fruitoftheloombasictshirt',
    'it-ch': '/esperti/servizi/dettagli/fruitoftheloombasictshirt',
    'it-it': '/esperti/servizi/dettagli/fruitoftheloombasictshirt',
    'nb-no': '/eksperter/tjenester/detaljer/fruitoftheloombasictshirt',
    'no-no': '/eksperter/tjenester/detaljer/fruitoftheloombasictshirt',
    'nl-be': '/experts/diensten/details/fruitoftheloombasictshirt',
    'nl-nl': '/experts/diensten/details/fruitoftheloombasictshirt',
    'pt-pt': '/especialistas/servicos/detalhes/fruitoftheloombasictshirt',
    'sv-se': '/experter/tjänster/information/fruitoftheloombasictshirt',
};

const vistaprintDesignFlyersUrls: { [key: string]: string } = {
    'da-dk': '/eksperter/ydelser/detaljer/flyersandleaflets',
    'de-at': '/experten/services/details/flyersandleaflets',
    'de-ch': '/experten/services/details/flyersandleaflets',
    'de-de': '/experten/services/details/flyersandleaflets',
    'en-au': '/experts/services/details/flyersandleaflets',
    'en-ca': '/experts/services/details/flyers',
    'en-gb': '/experts/services/details/flyersandleaflets',
    'en-ie': '/experts/services/details/flyersandleaflets',
    'en-nz': '/experts/services/details/flyersandleaflets',
    'en-sg': '/experts/services/details/flyersandleaflets',
    'en-us': '/experts/services/details/flyers',
    'es-es': '/expertos/servicios/detalles/flyersandleaflets',
    'es-us': '/expertos/servicios/detalles/flyers',
    'fi-fi': '/ammattilaiset/palvelut/tiedot/flyersandleaflets',
    'fr-be': '/experts/services/details/flyersandleaflets',
    'fr-ca': '/experts/services/details/flyers',
    'fr-ch': '/experts/services/details/flyersandleaflets',
    'fr-fr': '/experts/services/details/flyersandleaflets',
    'it-ch': '/esperti/servizi/dettagli/flyersandleaflets',
    'it-it': '/esperti/servizi/dettagli/flyersandleaflets',
    'nb-no': '/eksperter/tjenester/detaljer/flyersandleaflets',
    'no-no': '/eksperter/tjenester/detaljer/flyersandleaflets',
    'nl-be': '/experts/diensten/details/flyersandleaflets',
    'nl-nl': '/experts/diensten/details/flyersandleaflets',
    'pt-pt': '/especialistas/servicos/detalhes/flyersandleaflets',
    'sv-se': '/experter/tjänster/information/flyersandleaflets',
};

const vistaprintDesignServiceUrls: { [key: string]: string } = {
    'da-dk': '/design',
    'de-at': '/designservice',
    'de-ch': '/designservice',
    'de-de': '/designservice',
    'en-au': '/design',
    'en-ca': '/design',
    'en-gb': '/design',
    'en-ie': '/design',
    'en-in': '/design',
    'en-nz': '/design',
    'en-sg': '/design',
    'en-us': '/design',
    'es-es': '/un-diseno',
    'es-us': '/un-diseno',
    'fi-fi': '/suunnittelu',
    'fr-be': '/services-graphiques',
    'fr-ca': '/services-graphiques',
    'fr-ch': '/services-graphiques',
    'fr-fr': '/services-graphiques',
    'it-ch': '/servizi-grafici',
    'it-it': '/design',
    'nb-no': '/design',
    'no-no': '/design',
    'nl-be': '/ontwerp',
    'nl-nl': '/ontwerp',
    'pt-pt': '/design',
    'sv-se': '/design',
};

const categoryUrlsMap = {
    flyer: vistaprintDesignFlyersUrls,
    tshirt: vistaprintDesignTshirtsUrls,
    'business-card': vistaprintDesignBusinessCardsUrls,
};

const fallbackDesignServiceUrl = vistaprintDesignServiceUrls['en-us'];

const normalizeDesignServiceLocale = (locale: string) => {
    const cleanedUpLocale = locale.replace('_', '-').toLowerCase();

    return cleanedUpLocale === 'en-in' ? 'en-us' : cleanedUpLocale;
};

export function vistaI18nDesignServiceRoutesBy99dLocale(locale: string): string {
    const designServiceLocale = normalizeDesignServiceLocale(locale);

    return `${vistaI18nRoutesBy99dLocale(designServiceLocale)}${
        vistaprintDesignServiceUrls[designServiceLocale] || fallbackDesignServiceUrl
    }`;
}

export function vistaI18nDesignServiceRoutesBy99dLocaleAndCategory(
    locale: string,
    category: keyof typeof categoryUrlsMap
): string {
    const designServiceLocale = normalizeDesignServiceLocale(locale);
    const categoryUrls = categoryUrlsMap[category];

    return `${vistaI18nRoutesBy99dLocale(designServiceLocale)}${
        categoryUrls[designServiceLocale] || categoryUrls['en-us']
    }`;
}
